import { createContext, useContext } from 'react'

interface ResidentMessagesUnreadContextValue {
  unreadCount: number
  refresh: () => Promise<void>
}

const ResidentMessagesUnreadContext =
  createContext<ResidentMessagesUnreadContextValue | null>(null)

/**
 * Reads the resident's unread direct-message count + a refresh. Throws outside
 * the provider.
 *
 * @returns {ResidentMessagesUnreadContextValue}
 */
const useResidentMessagesUnread = (): ResidentMessagesUnreadContextValue => {
  const context = useContext(ResidentMessagesUnreadContext)
  if (context === null) {
    throw new Error(
      'useResidentMessagesUnread must be used within a ResidentMessagesUnreadProvider',
    )
  }
  return context
}

export {
  ResidentMessagesUnreadContext,
  type ResidentMessagesUnreadContextValue,
  useResidentMessagesUnread,
}
